//app/register/choice.tsx
import { StyleSheet, Text, TouchableOpacity, View, Dimensions, StatusBar } from 'react-native';
import { useTranslation } from 'react-i18next';
import Icon from 'react-native-vector-icons/FontAwesome';
import { useRouter } from 'expo-router';
import { getItem } from '../../src/lib/storage';
import ConfettiCannon from 'react-native-confetti-cannon';
import * as Animatable from 'react-native-animatable';
import { registrationSuccessRoute } from './registrationSuccessRoute';
import { RegistrationAppStoreLinks } from '../../src/components/appStores/AppStoreLinks';

export default function SuccessScreen() {
  const { t } = useTranslation('register');
  const router = useRouter();

  const handleOkPress = async () => {
    StatusBar.setBarStyle('default', true);
    StatusBar.setBackgroundColor('transparent', true);
    const token = await getItem('userToken');
    router.replace(registrationSuccessRoute(token));
  };

  return (
    <View style={styles.container}>
      <StatusBar barStyle="light-content" backgroundColor="#4BB543" />

      {/* Confetti Effect */}
      <ConfettiCannon 
        count={200}
        origin={{ x: 0, y: 0 }}
        autoStart={true}
        fadeOut={true}
        colors={['#4BB543', '#FFD700', '#FF69B4', '#00BFFF', '#FF4500', '#9370DB']}
      />

      {/* Animated Icon */}
      <Animatable.View animation="bounceIn" duration={1500}>
        <Icon name="check-circle" size={100} color="#4BB543" />
      </Animatable.View>

      <Animatable.Text animation="fadeInUp" delay={500} style={styles.title}>
        {t('registrationSuccessTitle')}
      </Animatable.Text>

      <Animatable.Text animation="fadeInUp" delay={700} style={styles.message}>
        {t('registrationSuccessMessage')}
      </Animatable.Text>

      {/* ALL-23: offer the app at the end of a web registration. */}
      <Animatable.View animation="fadeInUp" delay={800} style={styles.storeLinks}>
        <RegistrationAppStoreLinks />
      </Animatable.View>

      <Animatable.View animation="fadeInUp" delay={900}>
        <TouchableOpacity style={styles.button} onPress={handleOkPress}>
          <Text style={styles.buttonText}>{t('okButton')}</Text>
        </TouchableOpacity>
      </Animatable.View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#4BB543', // Green background
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  title: {
    fontSize: 28,
    fontWeight: 'bold',
    color: '#fff',
    marginTop: 20,
    textAlign: 'center',
  },
  message: {
    fontSize: 18,
    color: '#e0f7e9',
    marginTop: 10,
    textAlign: 'center',
    paddingHorizontal: 20,
  },
  storeLinks: {
    width: '100%',
    marginTop: 20,
  },
  button: {
    paddingVertical: 15,
    paddingHorizontal: 40,
    borderRadius: 8,
    marginTop: 20,
    marginBottom: 10,
    backgroundColor: '#fff',
  },
  buttonText: {
    color: '#4BB543',
    fontSize: 18,
    fontWeight: '600',
  },
});